const {KitModule, registerModule} = window;

class Accordion extends KitModule {
  constructor($element) {
    super($element);
    this.init();
  }

  init() {
    this.openID = null;
    this.bindEvents();
  }

  bindEvents() {
    // Print
    window.addEventListener('beforeprint', this.beforePrint.bind(this));
    window.addEventListener('afterprint', this.afterPrint.bind(this));
  }

  openAllDisclosures() {
    this.$details.forEach(($detail) => {
      $detail.setAttribute('open', '');
    });
  }

  closeAllDisclosures() {
    this.$details.forEach(($detail) => {
      if ($detail.hasAttribute('open')) {
        $detail.removeAttribute('open');
      }
    });
  }

  beforePrint() {
    this.$details.forEach(($detail) => {
      if ($detail.hasAttribute('open')) {
        this.openID = $detail.querySelector('summary').id;
      }
    });
    this.openAllDisclosures();
  }

  afterPrint() {
    this.closeAllDisclosures();
    document.getElementById(this.openID).parentNode.setAttribute('open', '');
  }

  unmount() {}
}

registerModule('Accordion', Accordion);
